const mEditionAssetContentCommentsCreate = {
  mEditionAssetContentCommentsCreate: {
    actions: {
      sendAnswer: 'Enviar Respuesta',
      sendingAnswer: 'Enviando Respuesta',
      sendComment: 'Enviar Comentario',
      sendMessage: 'Enviar Mensaje',
      sendingMessage: 'Enviando Mensaje',
      sendingComment: 'Enviando Comentario',
      sendingQuestion: 'Enviando Pregunta',
      sendQuestion: 'Enviar Pregunta',
      sentAnswer: {
        firstText: 'Hola',
        secondText: 'Tu pregunta ha sido enviada correctamente. Cuando te responda te informaré a tu correo electrónico para que puedas verla aquí mismo dentro de la academia.'
      }
    },

    placeholder: {
      writeAnswer: 'Escribir aquí ...',
      writeComment: 'Escribir aquí ...',
      writeQuestion: 'Escribir aquí ...'
    }
  }
}

export default mEditionAssetContentCommentsCreate
